<main class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1>Adquirir licença</h1>
        </div>
    </div>
    <div class="row mx-5">
        <div class="col-12">
            <form [formGroup]="licencaForm">
                <div class="row">
                    <div class="form-group col-6">
                        <label id="label-input">
                            <span>Licença:</span>
                        </label>
                        <select type="number" formControlName="fk_licenca" class="input form-control form-control-sm"
                            required>
                            <option [value]="licenca.sr_id" *ngFor="let licenca of licencas">
                                {{ licenca.vc_nome }}
                            </option>
                        </select>
                        <ng-container *ngIf="licencaForm.controls.fk_licenca.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.fk_licenca.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-6">
                        <label id="label-input">
                            <span>Usina:</span>
                        </label>
                        <select type="number" formControlName="fk_cliente" class="input form-control form-control-sm"
                            required>
                            <option [value]="usina.sr_id" *ngFor="let usina of usinas">
                                {{ usina.vc_nome }}
                            </option>
                        </select>
                        <ng-container *ngIf="licencaForm.controls.fk_cliente.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.fk_cliente.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-4">
                        <label id="label-input">
                            <span>Data de ativação:</span>
                        </label>
                        <input formControlName="ts_ativacao" class="input form-control form-control-sm" type="date"
                            [min]="dataMinima" onkeydown="return false">
                        <ng-container *ngIf="licencaForm.controls.ts_ativacao.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.ts_ativacao.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-4">
                        <label id="label-input">
                            <span>Período da licença (dias): </span>
                        </label>
                        <input formControlName="it_dias_duracao" class="input form-control form-control-sm" type="number"  >
                        <ng-container *ngIf="licencaForm.controls.it_dias_duracao.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.it_dias_duracao.errors">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                
                    <div class="form-group col-4">
                        <label id="label-input">
                            <span>Identificador da licença:</span>
                        </label>
                        <select formControlName="select_opcoes" class="input form-control form-control-sm" required>
                            <option value="vc_nota_fiscal">
                                Nota Fiscal
                            </option>
                            <option value="vc_ordem_servico">
                                Ordem de Serviço (Manutenção)
                            </option>
                            <option value="vc_proposta">
                                Proposta 
                            </option>
                            <ng-container *ngIf="licencaForm.controls.it_dias_duracao.touched">
                                <p class="msg-erro" *ngIf="licencaForm.controls.it_dias_duracao.errors">
                                    Campo obrigatório *
                                </p>
                            </ng-container>
                        </select>
                        <ng-container *ngIf="licencaForm.controls.select_opcoes.touched">
                            <p class="msg-erro" *ngIf="licencaForm.controls.select_opcoes.errors?.required">
                                Campo obrigatório *
                            </p>
                        </ng-container>
                    </div>
                    <div class="form-group col-6" *ngFor="let campo of campos">
                        <label id="label-input">
                            <span>{{campo.nome_campo}}:</span>
                        </label>
                        <input [formControlName]="campo.nome_formulario" class="input form-control form-control-sm"
                            type="text">
                    </div>
                    <div class="form-group col-6">
                        <div *ngIf="campoSelecionado === 'vc_nota_fiscal'" class="form-group">
                            <label id="label-input" for="vc_nota_fiscal">
                                <span>Nota Fiscal:</span>
                            </label>
                            <input formControlName="vc_nota_fiscal" id="vc_nota_fiscal" type="number"
                                class="input form-control form-control-sm" />
                        </div>
                        <div *ngIf="campoSelecionado === 'vc_ordem_servico'" class="form-group">
                            <label id="label-input" for="vc_ordem_servico">
                                <span>Ordem de Serviço (Manutenção):</span>
                            </label>
                            <input formControlName="vc_ordem_servico" id="vc_ordem_servico" type="number"
                                class="input form-control form-control-sm" />
                        </div>
                        <div *ngIf="campoSelecionado === 'vc_proposta'" class="form-group">
                            <label id="label-input" for="vc_proposta">
                                <span>Proposta:</span>
                            </label>
                            <input formControlName="vc_proposta" id="vc_proposta" type="number"
                                class="input form-control form-control-sm" />
                        </div>
                    </div>
                    <div class="form-group col-12">
                        <mat-checkbox [checked]="checked"
                            (change)="checked = !checked; toggleFormControl('vc_nota_fiscal', checked); toggleFormControl('vc_ordem_servico', checked)">
                            Demonstração </mat-checkbox>
                    </div>
                </div>
                <div id="buttons">
                    <button class="btn-sucesso btn btn-lg btn-success" type="submit"
                        [ngClass]="{ 'btn-desabilitado': !licencaForm.valid }" [disabled]="!licencaForm.valid"
                        (click)="adquirirLicenca()">
                        Adquirir licença
                    </button>
                    <button class="btn-cancelar btn btn-lg btn-danger" type="button" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </div>
</main>